import * as types from './types';

// Генерация уникального ID
const generateId = () => `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

// Типы объектов
export const OBJECT_TYPES = {
  territory: { label: 'Территория', icon: 'FaMapMarkerAlt', allowedChildren: ['building'] },
  building: { label: 'Здание', icon: 'FaBuilding', allowedChildren: ['floor'] },
  floor: { label: 'Этаж', icon: 'FaLayerGroup', allowedChildren: ['room'] },
  room: { label: 'Аудитория', icon: 'FaDoorOpen', allowedChildren: [] }
};

// === ОБЪЕКТЫ ===

export const setObjects = (objects) => ({
  type: types.SET_INFO_TERMINAL_OBJECTS,
  payload: objects
});

export const addObject = (parentId = null) => (dispatch, getState) => {
  const { objects } = getState().infoTerminal;

  // Определяем тип нового объекта
  let type = 'territory';
  if (parentId) {
    const parent = objects.find(obj => obj.id === parentId);
    if (parent) {
      const parentType = OBJECT_TYPES[parent.type];
      if (parentType && parentType.allowedChildren.length > 0) {
        type = parentType.allowedChildren[0];
      }
    }
  }

  // Считаем порядок сортировки
  const siblings = objects.filter(obj => obj.parentId === parentId);
  const sortOrder = siblings.length + 1;

  const newObject = {
    id: generateId(),
    type,
    name: `Новый ${OBJECT_TYPES[type].label.toLowerCase()}`,
    description: '',
    parentId,
    sortOrder,
    isActive: true,
    image: null,
    areas: []
  };

  dispatch({
    type: types.ADD_INFO_TERMINAL_OBJECT,
    payload: newObject
  });

  dispatch(setSelectedObject(newObject.id));

  return newObject;
};

export const updateObject = (id, updates) => ({
  type: types.UPDATE_INFO_TERMINAL_OBJECT,
  payload: { id, ...updates }
});

export const deleteObjectLocal = (id) => ({
  type: types.DELETE_INFO_TERMINAL_OBJECT,
  payload: id
});

export const reorderObjects = (parentId, orderedIds) => (dispatch, getState) => {
  const { objects } = getState().infoTerminal;
  const updatedObjects = objects.map(obj => {
    const index = orderedIds.indexOf(obj.id);
    if (index !== -1 && obj.parentId === parentId) {
      return { ...obj, sortOrder: index + 1 };
    }
    return obj;
  });
  dispatch(setObjects(updatedObjects));
};

// === ВЫБОР ===

export const setSelectedObject = (id) => ({
  type: types.SET_INFO_TERMINAL_SELECTED_OBJECT,
  payload: id
});

export const setSelectedArea = (areaId) => ({
  type: types.SET_INFO_TERMINAL_SELECTED_AREA,
  payload: areaId
});

export const refreshAreas = () => ({
  type: types.REFRESH_INFO_TERMINAL_AREAS
});

export const refreshImage = () => ({
  type: types.REFRESH_INFO_TERMINAL_IMAGE
});

// === РЕДАКТОР ===

export const setEditorMode = (mode) => ({
  type: types.SET_INFO_TERMINAL_EDITOR_MODE,
  payload: mode
});

export const addDrawingPoint = (point) => ({
  type: types.ADD_INFO_TERMINAL_DRAWING_POINT,
  payload: point
});

export const setDrawingPoints = (points) => ({
  type: types.SET_INFO_TERMINAL_DRAWING_POINTS,
  payload: points
});

export const clearDrawingPoints = () => ({
  type: types.CLEAR_INFO_TERMINAL_DRAWING_POINTS
});

export const setStageScale = (scale) => ({
  type: types.SET_INFO_TERMINAL_STAGE_SCALE,
  payload: scale
});

export const setStagePosition = (position) => ({
  type: types.SET_INFO_TERMINAL_STAGE_POSITION,
  payload: position
});

export const setHasChanges = (value) => ({
  type: types.SET_INFO_TERMINAL_HAS_CHANGES,
  payload: value
});

// === ОБЛАСТИ (ПОЛИГОНЫ) ===

export const addArea = (objectId, points) => (dispatch, getState) => {
  const { objects } = getState().infoTerminal;
  const object = objects.find(obj => obj.id === objectId);
  const existingAreas = object?.areas || [];

  const newArea = {
    id: generateId(),
    points,
    linkedObjectId: null,
    sortOrder: existingAreas.length + 1,
    isActive: true
  };

  dispatch({
    type: types.ADD_INFO_TERMINAL_AREA,
    payload: { objectId, area: newArea }
  });

  dispatch(setSelectedArea(newArea.id));
  dispatch(clearDrawingPoints());
  dispatch(setEditorMode('select'));

  return newArea;
};

export const updateArea = (areaId, updates) => ({
  type: types.UPDATE_INFO_TERMINAL_AREA,
  payload: { areaId, updates }
});

export const deleteArea = (objectId, areaId) => ({
  type: types.DELETE_INFO_TERMINAL_AREA,
  payload: { objectId, areaId }
});

// === ИЗОБРАЖЕНИЕ ===
// Функции uploadImage и deleteImage перенесены в infoTerminalApi.js
// Используйте uploadImageToServer и deleteImageFromServer из infoTerminalApi

// === СЕЛЕКТОРЫ ===

export const selectObjects = (state) => state.infoTerminal.objects;

export const selectSelectedObject = (state) => {
  const { objects, selectedObjectId } = state.infoTerminal;
  return objects.find(obj => obj.id === selectedObjectId) || null;
};

export const selectSelectedArea = (state) => {
  const { objects, selectedObjectId, selectedAreaId } = state.infoTerminal;
  const object = objects.find(obj => obj.id === selectedObjectId);
  if (!object || !object.areas) return null;
  return object.areas.find(area => area.id === selectedAreaId) || null;
};

export const selectChildObjects = (state, parentId) => {
  return state.infoTerminal.objects.filter(obj => obj.parentId === parentId);
};

// Построение дерева из плоского списка
export const selectObjectTree = (state) => {
  const { objects } = state.infoTerminal;

  const buildTree = (parentId) => {
    return objects
      .filter(obj => obj.parentId === parentId)
      .sort((a, b) => a.sortOrder - b.sortOrder)
      .map(obj => ({
        ...obj,
        children: buildTree(obj.id)
      }));
  };

  return buildTree(null);
};
